// api/axiosClient.js
import axios from "axios";
import { baseUrl } from "../dummy";

// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#requestconfig` for the full list of configs
const axiosClient = axios.create({
  baseURL: baseUrl,
  headers: {
    "content-type": "application/json",
    "x-access-token": sessionStorage.getItem("auth"),
    "Access-Control-Allow-Origin": "*",
  },
});
axiosClient.interceptors.request.use(async (config) => {
  return config;
});
axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    // Handle errors
    throw error;
  }
);
export default axiosClient;
